import React from "react";
import Header from "../Home/header/Header";
import Cover from "./cover/Cover";
import Content from "./content/Content";
import Section4 from "../Home/section4/Section4";
import Footer from "../Home/footer/Footer";

function Services() {
  return (
    <div>
      <Header />
      <Cover />
      <Content />
      <Section4 />
      <Footer />
    </div>
  );
}

export default Services;
